import { useQuery } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import type { ApprovalEntry } from '@tailorcast/shared-types';

export function usePendingApprovals() {
  return useQuery({
    queryKey: ['approvals', 'pending'],
    queryFn: () => api.get<{ approvals: ApprovalEntry[] }>(TASKS.APPROVALS_PENDING),
    refetchInterval: 5000,
  });
}
